/*
	Сохраняем параметрі сортировки в localStorage
*/

export const setSortParameters = (sortMethod: string, sortBy: string) => {
	localStorage.setItem("accountsSortMethod", sortMethod);
	localStorage.setItem("accountsSortBy", sortBy);
};

export const getSortParameters = () => {
	return {
		sortMethod: localStorage.getItem("accountsSortMethod"),
		sortBy: localStorage.getItem("accountsSortBy"),
	};
};
